import React from "react";

export type StatTone =
  | "primary"
  | "success"
  | "warning"
  | "info"
  | "danger"
  | "neutral";

interface StatCardProps {
  title: string;
  value: React.ReactNode;
  icon: string;
  tone?: StatTone;
}

const StatCard: React.FC<StatCardProps> = ({
  title,
  value,
  icon,
  tone = "primary",
}) => {
  return (
    <div className={`statCard statCard--${tone}`}>
      <div className="statCard__iconWrap">
        <i className={`bi ${icon}`} aria-hidden="true"></i>
      </div>
      <div className="statCard__body">
        <div className="statCard__label">{title}</div>
        <div className="statCard__value">{value}</div>
      </div>
    </div>
  );
};

export default StatCard;
